import type { CcmPlaceholderEntry, CcmSectionPlaceholdersResponse, CcmTranslationsResponse, CcmCommunicationResponse, CcmSectionResponse, CcmSegment } from '@arhs-fleetback/types/entities/ccm';

type PlaceholdersLike = Partial<CcmSectionPlaceholdersResponse> | undefined;
type EmailPlaceholders = NonNullable<CcmSectionPlaceholdersResponse['email']>;

export const resolveSegments = (
  sectionConfig: CcmSectionResponse | undefined,
  communicationConfig: CcmCommunicationResponse,
): CcmSegment[] | undefined =>
  communicationConfig.segments ?? sectionConfig?.segments;

export const resolveSmsPlaceholders = (
  sectionPlaceholders: PlaceholdersLike,
  communicationPlaceholders: PlaceholdersLike,
): CcmPlaceholderEntry[] =>
  communicationPlaceholders?.sms ?? sectionPlaceholders?.sms ?? [];

export const resolveEmailPlaceholders = (
  sectionPlaceholders: PlaceholdersLike,
  communicationPlaceholders: PlaceholdersLike,
): EmailPlaceholders =>
  communicationPlaceholders?.email ?? sectionPlaceholders?.email ?? {};

const BR = '<br>';

const EMAIL_KEY = 'email';

const applyToEmailStringValues = (
  ccmData: Record<string, unknown>,
  transform: (s: string) => string,
  isEmail = false,
): Record<string, unknown> =>
  Object.entries(ccmData).reduce<Record<string, unknown>>((acc, [key, value]) => {
    if (typeof value === 'string') {
      acc[key] = isEmail ? transform(value) : value;
    } else if (value !== null && typeof value === 'object') {
      acc[key] = applyToEmailStringValues(value as Record<string, unknown>, transform, isEmail || key === EMAIL_KEY);
    } else {
      acc[key] = value;
    }
    return acc;
  }, {});

export const parseCcmContent = (data: CcmTranslationsResponse): CcmTranslationsResponse =>
  applyToEmailStringValues(data as Record<string, unknown>, value => value.replaceAll(BR, '\n')) as CcmTranslationsResponse;

export const formatCcmContent = (data: CcmTranslationsResponse): CcmTranslationsResponse =>
  applyToEmailStringValues(data as Record<string, unknown>, value => value.replace(/\n/g, BR)) as CcmTranslationsResponse;
